module.exports = {"id":"204539","name":"Luis Advíncula","rating":"72","photo":"./data/images/photos/3/204539.png","club":{"name":"Lobos B.U.A.P.","logo":"./data/images/clubs/LobosB.U.A.P..png"},"positions":["DD","DLD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LuisAdvincula0.json
// module id = 2605
// module chunks = 0